import { apiDate, number, optional, string, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

export const ApiOrgProductSchema = zodLess({
  id: string,
  orgId: string,
  productSupplierOrgId: optional(string),
  productSupplierSku: optional(string),
  productSupplier: optional(string),
  thdStoreSku: optional(string),

  sku: optional(string),
  title: optional(string),
  description: optional(string),
  price: optional(number),
  brand: optional(string),
  image: optional(string),
  color: optional(string),
  productId: optional(string),

  archivedAt: optional(apiDate),
  createdAt: apiDate,
  updatedAt: apiDate,
});

const READ_ONLY_FIELDS = { id: true, createdAt: true, updatedAt: true, orgId: true } as const;
export const ApiCreateOrgProductSchema = ApiOrgProductSchema.omit(READ_ONLY_FIELDS);
export const ApiUpdateOrgProductSchema = ApiOrgProductSchema.omit(READ_ONLY_FIELDS).partial({});

export type ApiOrgProduct = ZodLessInfer<typeof ApiOrgProductSchema>;
export type ApiCreateOrgProduct = ZodLessInfer<typeof ApiCreateOrgProductSchema>;
export type ApiUpdateOrgProduct = ZodLessInfer<typeof ApiUpdateOrgProductSchema>;

/**
 * Only valid with THD products. Check with:
 * const { productSupplierOrgs, productSuppliersLoading } = useAllProductSupplierOrgs();
 * const thdOrgId = productSupplierOrgs?.homeDepot?.id;
 * if (product.productSupplierOrgId === thdOrgId) {
 *   const thdInSock = getThdIsProductInStock(product);
 * }
 *
 * TODO: add some sort of inStock info to either ApiOrgProductSchema or a more general purpose inStock system
 */
export const getThdIsProductInStock = (product: ApiOrgProduct) => product.thdStoreSku != null && product.thdStoreSku !== '';

export const getOrgProductQueryKeyPrefix = (): string => `orgProduct/`;
export const getOrgProductQueryKey = (id: string): string => `${getOrgProductQueryKeyPrefix()}${id}`;
export const getOrgProductsQueryKeyWithArchived = (orgId: string | undefined, archived: boolean): string =>
  `orgProducts/${orgId ?? 'undefined'}/${archived ? 'archived' : 'active'}`;
export const getOrgProductsFilterQueryKey = (orgId: string | undefined, options: { archived?: boolean; queryString?: string; limit?: number }): string =>
  `orgProducts/${orgId ?? 'undefined'}/${options.archived ? 'archived' : 'active'}${options.queryString ? `/search/${options.queryString}` : ''}${
    options.limit ? `/limit/${options.limit}` : ''
  }`;
